import $ from "jquery";
import {Popup} from "./Popups/Popup";
import {BaseHandler} from "./Handlers/BaseHandler";
import {LoadDataHandler} from "./Handlers/LoadDataHandler";

import {ManageBatchesHandler} from "./Handlers/ManageBatchesHandler";
import {PrintLettersHandler} from "./Handlers/PrintLettersHandler";
import {ClosePrintingBatchesHandler} from "./Handlers/ClosePrintingBatchesHandler";
import {ExportPaymentsHandler} from "./Handlers/ExportPaymentsHandler";
import {SentEmailReportsHandler} from "./Handlers/SentEmailReportsHandler";
import {LoginHandler} from "./Handlers/LoginHandler";
import {ManageReportersHandler} from "./Handlers/ManageReportersHandler";
import {ManageCustomerEntitiesHandler} from "./Handlers/ManageCustomerEntitiesHandler";
import {TemplateHandler} from "./Handlers/TemplateHandler";

export class Smartprise {
    public handler: BaseHandler;

    public RegisterEvents() {
        const url_params = new URLSearchParams(window.location.search);
        //@ts-ignore
        const page = globalThis.page ?? url_params.get("page");

        const handlers: { [page: string]: typeof BaseHandler } = {
            load_data: LoadDataHandler,
            manage_batches: ManageBatchesHandler,
            print_letters: PrintLettersHandler,
            close_printing_batches: ClosePrintingBatchesHandler,
            export_payments: ExportPaymentsHandler,
            sent_email_reports: SentEmailReportsHandler,
            manage_reporters: ManageReportersHandler,
            manage_customer_entities: ManageCustomerEntitiesHandler,
            login: LoginHandler,
            template_editor: TemplateHandler,
        };

        const HandlerClass = handlers[page];

        if (!HandlerClass) {
            console.error(`No handler found for page: ${page}`);
            return;
        }

        this.handler = new HandlerClass();
        this.handler.handle();
    }
}


// @ts-ignore
globalThis.smartprise = new Smartprise();
// @ts-ignore
globalThis.Popup = Popup;
// @ts-ignore
globalThis.TS$ = $;

// @ts-ignore
$(() => globalThis.smartprise.RegisterEvents());